import "./my-orders.scss";
import OrderCollapse from "../../components/order-collapse/order-collapse";
import MyAccountWrapper from "../../layout/my-account-wrapper/my-account-wrapper";
import { useContext, useEffect, useState } from "react";
import { LoadingContext } from "../../contexts/loadingContext";
import { FranchiseContext } from "../../contexts/franchiseContext";
import api from "./../../services/api";

const pageDescription = (
  <div className={"mb-4"}>
    Oi <strong>Fábio Onofre</strong>.
    <br />
    <br />
    Acompanhe todo o histórico dos seus pedidos na Adoleta.
  </div>
);

function MyOrders() {
  const [orders, setOrders] = useState([]);

  const { setIsLoadingGlobal } = useContext(LoadingContext);

  const { franchise } = useContext(FranchiseContext);

  const getOrders = () => {
    if (!franchise?.id) {
      const redirectUrl = `${window.location.pathname}${window.location.search}`;
      window.location.href = `/login?showAlert=true&redirectUrl=${redirectUrl}`;
    }
    try {
      setIsLoadingGlobal(true);
      api.get(`client/orders?franchise_id=${franchise.id}`).then((response) => {
        setOrders(response.data);
      });
    } catch (e) {
    } finally {
      setIsLoadingGlobal(false);
    }
  };

  useEffect(() => {
    getOrders();
  }, []);

  return (
    <MyAccountWrapper
      pageName={"Meus Pedidos"}
      pageDescription={pageDescription}
    >
      {orders.map((order) => (
        <OrderCollapse
          orderData={order}
          key={order.id}
          isPayment={
            order.payment_type.name === "PIX/TED" && order.status.code === 1
          }
        />
      ))}
    </MyAccountWrapper>
  );
}

export default MyOrders;
